import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {hideModal} from '../../../actions/modal.actions';
import { getSystemLocations,getGeneralLedgers,getGeneralLedgerSubAccounts } from '../../../actions/admin.actions';
import {  getModalData, getAdmin, getProducts} from '../../../selectors';
import { getInstallmentPlan,clearInstallmentPlan} from "../../../actions/products.action";
import {FieldArray, Formik} from 'formik';
import NumericInput from 'react-numeric-input';
import isEmpty, { action } from "../../../utils/helpers";
import FormSelect from "../../../components/UI/FormSelect";
import TextInput from "../../../components/UI/TextInput";
import DatePicker from "react-datepicker";
import Loader from "../../../components/Loader";
import * as Yup from "yup";
import {actions, toastr} from "react-redux-toastr";
import axiosInstance from '../../../utils/axios-instance';
const asOptions = (source, mapper) => {
    if (!Array.isArray(source)) {
        return [];
    }

    return source.map(mapper);
}

const systemLocationAsOptions = (systemLocations) => asOptions(systemLocations, systemLocation => {
    return {
        label: systemLocation.description,
        value: systemLocation.id,
    }
});

const removeSelectedLocations = (locations, ignoreIndex, selectedGeneralLedgers) => {
    let currentLocations = [];
    if(locations && locations != undefined && !isEmpty(selectedGeneralLedgers)) {
        selectedGeneralLedgers.map((selectedLocation, index) => {
            if(ignoreIndex != index) {
                currentLocations.push(selectedLocation.glLocationId);
            }
        });
        return locations.filter(location => !currentLocations.includes(location.id));
    }
    return locations;
}

const generalLedgersAsOptions = (generalLedgers) => asOptions(generalLedgers, generalLedger => {
    return {
        label: generalLedger.accountNumber,
        value: generalLedger.id,
    }
});

const generalLedgersSubAccountsAsOptions = (generalLedgerSubAccounts) => asOptions(generalLedgerSubAccounts, generalLedgerSubAccount => {
    return {
        label: generalLedgerSubAccount.subAccountNumber,
        value: generalLedgerSubAccount.id,
    }
});

const matchCurrentSelectedGeneralLedger = (generalLedgerSubAccounts, selectedId) => {
    if ((generalLedgerSubAccounts && generalLedgerSubAccounts != undefined)) {
        return generalLedgerSubAccounts.filter(generalLedgerSubAccount => generalLedgerSubAccount.generalLedgerId == selectedId);
    }
    return generalLedgerSubAccounts;
}



class AddInstallmentPlanModal extends Component {

    state = {
        selectedGeneralLedgers: [],
        generalLedgersToDelete:[],
        isInstallmentPlanLoading: true,
        data:{}
    };

    componentDidMount() {
        this.props.clearInstallmentPlan();
        this.props.getSystemLocations();
        this.props.getGeneralLedgers()
        this.props.getGeneralLedgerSubAccounts();
        const {modalProps} = this.props;
        let selectedGeneralLedgers = [{
            glLocationId: '',
            glSubId: '',
            glId: '',
            glDescription: ''
        }];
        if(modalProps.value) {
            this.props.getInstallmentPlan(modalProps.value).then((response) => {
                this.setState({data:response});
                if(response.selectedGeneralLedgers){
                    selectedGeneralLedgers = response.selectedGeneralLedgers;
                }
                this.setState({
                    isInstallmentPlanLoading: false,
                    selectedGeneralLedgers: selectedGeneralLedgers
                })
            })
        }else{
            this.setState({
                isInstallmentPlanLoading: false,
                selectedGeneralLedgers: selectedGeneralLedgers
            })
        }

    }

    componentWillUnmount() {
        this.props.clearInstallmentPlan();
    }

    addAnotherGeneralLedger = (selectedGeneralLedgers) => {
        selectedGeneralLedgers.push({
            glLocationId: '',
            glSubId: '',
            glId: '',
            glDescription: ''
        });
        this.setState({
            selectedGeneralLedgers: selectedGeneralLedgers
        });
    }

    setGeneralLedgerValue = (e, value, setFieldValue, index) => {
        setFieldValue(`selectedGeneralLedgers.${index}.glId`, value);
        if(this.props.generalLedgers != undefined){
            this.setGeneralLedgerDescription(value, setFieldValue, index);
            setFieldValue(`selectedGeneralLedgers.${index}.glSubId`, "");
        }
        this.setState({
            generalLedgerSelected: true
        })
    }

    setGeneralLedgerLocationValue = (e, value, setFieldValue, index) => {
        setFieldValue(`selectedGeneralLedgers.${index}.glLocationId`, value);
        this.setState({
            generalLedgerSelected: true
        })
    }

    setGeneralLedgerDescription = (value, setFieldValue, index) => {
        this.props.generalLedgers.map(ledger => {
            if(ledger.id == value){
                setFieldValue(`selectedGeneralLedgers.${index}.glDescription`, ledger.description);
            }
        })
    }

    handleRemoveGeneralLedger = (formProps, remove, index, setFieldValue) => {
        let generalLedgersToDelete = this.state.generalLedgersToDelete;
        if(formProps.values.selectedGeneralLedgers != undefined){
            let values = {...formProps.values};
            if(values.selectedGeneralLedgers[index].glSubId != undefined) {
                generalLedgersToDelete.push(values.selectedGeneralLedgers[index].id);
                this.setState({
                    generalLedgersToDelete: generalLedgersToDelete
                })
            }
            values.selectedGeneralLedgers.splice(index, 1);
            if(values.selectedGeneralLedgers.length == 0){
                values.selectedGeneralLedgers =  [{
                    glLocationId: '',
                    glSubId: '',
                    glId: '',
                    glDescription: ''
                }];
                this.setState({
                    generalLedgerSelected: false
                })
            }
            setFieldValue('selectedGeneralLedgers', values.selectedGeneralLedgers);
        }
    }

    buildGeneralLedgerTitle(selectedGeneralLedger) {
        let glString = "";
        if(selectedGeneralLedger.glLocationId){
            if(this.props.systemLocations != undefined){
                this.props.systemLocations.map(location => {
                    if(location.id == selectedGeneralLedger.glLocationId){
                        glString += location.name;
                    }
                })
            }
        }
        if(selectedGeneralLedger.glId){
            if(this.props.generalLedgers != undefined){
                this.props.generalLedgers.map(generalLedger => {
                    if(generalLedger.id == selectedGeneralLedger.glId){
                        glString += (":" + generalLedger.accountNumber);
                    }
                })
            }
        }
        if(selectedGeneralLedger.glSubId){
            if(this.props.generalLedgerSubAccounts != undefined){
                this.props.generalLedgerSubAccounts.map(generalLedgerSubAccount => {
                    if(generalLedgerSubAccount.id == selectedGeneralLedger.glSubId){
                        glString += ( "." + generalLedgerSubAccount.subAccountNumber) ;
                    }
                })
            }
        }
        return glString;
    }

    planSchema = () => {
        let validationSchema = {
            name: Yup.string().required('Required'),
            description: Yup.string().required('Required'),
            planCategoryId: Yup.string().required('Required').typeError('Required'),
            serviceModelId: Yup.string().required('Required').typeError('Required'),
            startDateTime: this.props.modalProps.type === 'create' ? Yup.date().required('Required').typeError('Required') : '',
            selectedGeneralLedgers: this.state.generalLedgerSelected ? Yup.array(Yup.object().shape({
                glLocationId: Yup.number().required('Required').typeError('Required'),
                glId: Yup.number().required('Required').typeError('Required'),
                glSubId: Yup.number().required('Required').typeError('Required')
            })).min(1): '',
        };

        return Yup.object().shape(validationSchema);
    }

    setMinPercentage = (value, setFieldValue) => {
        if(value <= 100 && value >= 0) {
            setFieldValue('upfrontPercentage', value);
        }
    }

    formSubmit = (values, actions) => {
        const { currentUser,modalProps } = this.props;
        const generalLedgersToDelete=this.state.generalLedgersToDelete;
        values.selectedGeneralLedgers.map((leg)=>{generalLedgersToDelete.push(leg.id);delete leg['id'];});
        this.setState({generalLedgersToDelete:generalLedgersToDelete})
        const validate=values.name&&values.description&&values.months&&values.months>0;
        const submitData =modalProps.type==='create'?{
                "planItemId": null,
                "name": values.name.toUpperCase(),
                "description": values.description,
                "estimatedMonthly": null,
                "upfrontPercentage": values.upfrontPercentage,
                "upfront": null,
                "months": values.months,
                "startDate": new Date(values.startDate).getTime(),
                "endDate": new Date(values.endDate).getTime(),
                "selectedGeneralLedgers": values.selectedGeneralLedgers,
                "generalLedgersToDelete": null,
                "active": values.active
        }:{...values,name:values.name.toUpperCase(),id:this.state.data.id,estimatedMonthly:this.state.data.estimatedMonthly,generalLedgersToDelete:this.state.generalLedgersToDelete,itemId:this.state.data.itemId,planItemId:this.state.data.planItemId,upfront:this.state.data.upfront};

        modalProps.type==='create'?validate&&axiosInstance.post(`/product/installmentPlan`,submitData).then((response) => {
            if (!response) {
                return;
            }
            //If any failures happen on edit or create, show the error, only refresh if edit
            if (response.status===200) {
                this.props.hideModal();
                this.props.modalProps.reloadFunction(true);
                toastr.success('New Installment Plan Added Successfully', {timeOut: 3000, position: 'top-center'});
            } else {
                toastr.error('Something went wrong!!', {timeOut: 3000, position: 'top-center'});
                this.props.hideModal();
            }
        }):validate&&axiosInstance.patch('/product/installmentPlan',submitData).then((response)=>{
            if (!response) {
                return;
            }
            //If any failures happen on edit or create, show the error, only refresh if edit
            if (response.status===200) {
                this.props.hideModal();
                this.props.modalProps.reloadFunction(true);
                toastr.success('Installment Plan Updated Successfully', {timeOut: 3000, position: 'top-center'});
            } else {
                toastr.error('Something went wrong!!', {timeOut: 3000, position: 'top-center'});
                this.props.hideModal();
            }
        })
    }

    scrollDropdownIntoView = (e) => {
        const elementClicked = e.target.nodeName;
        const boundingElement = e.currentTarget;
        const modalBody = document.getElementsByClassName('modal-body')[0];

        if (elementClicked !== 'LABEL') {

            setTimeout(function () {

                // Scroll down if the bottom is hidden...
                if (boundingElement.getBoundingClientRect().bottom > modalBody.getBoundingClientRect().bottom) {

                    // ... and the top won't end up hidden by scrolling down
                    if (boundingElement.getBoundingClientRect().height < modalBody.getBoundingClientRect().height) {

                        // Scroll down till bottom of element reaches bottom of screen
                        boundingElement.scrollIntoView({block: "end"});
                    }
                }
            }, 200);
        }
    }


    render() {
        const { isInstallmentPlanLoading } = this.state;
        const { modalProps, installmentplan, planCategories, systemLocations} = this.props;


        return (
            <Fragment>
                <div className="modal" style={{display: 'block'}} tabIndex="-1" role="dialog">
                    {isInstallmentPlanLoading &&
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {modalProps.type === 'create' ? 'Add Installment Plan' : 'Edit Installment Plan'}
                                </h5>
                                <button onClick={this.props.hideModal} type="button" className="close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <Loader />
                            <div className="modal-footer">
                                <button onClick={this.props.hideModal} className="btn" type="button">
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    {modalProps.type === 'create' ? 'Add Installment Plan' : 'Edit Installment Plan'}
                                </button>
                            </div>
                        </div>
                    </div>
                    }
                    {!isInstallmentPlanLoading &&
                    <Formik
                        initialValues={{
                            active: modalProps.type === 'create' ? true : installmentplan && installmentplan.active,
                            id: installmentplan && installmentplan.planId || null,
                            name: installmentplan &&  installmentplan.name || '',
                            description: installmentplan && installmentplan.description || '',
                            startDate: installmentplan && installmentplan.startDate || null,
                            endDate: installmentplan && installmentplan.endDate || null,
                            months: installmentplan?installmentplan.months: 12,
                            upfrontPercentage:installmentplan?installmentplan.upfrontPercentage: 0.00,
                            selectedGeneralLedgers: installmentplan&&installmentplan.selectedGeneralLedgers?installmentplan.selectedGeneralLedgers:this.state.selectedGeneralLedgers,
                            generalLedgersToDelete: installmentplan&&installmentplan.generalLedgersToDelete?installmentplan.generalLedgersToDelete:this.state.generalLedgersToDelete
                        }}
                        validationSchema={this.planSchema()}
                        onSubmit={this.formSubmit}
                        render={(props)=>{
                            const {
                                handleChange,
                                handleSubmit,
                                handleBlur,
                                values,
                                errors,
                                touched,
                                isSubmitting,
                                setFieldValue
                            } = props;
                            return <form onSubmit={handleSubmit} noValidate>
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">
                                                {modalProps.type === 'create' ? 'Add Installment Plan' : 'Edit Installment Plan'}
                                            </h5>
                                            <button onClick={this.props.hideModal} type="button" className="close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body form-horizontal">
                                            <div className="form-group">
												<span className="h-check">
													<label>&nbsp;Active&nbsp;</label>
													<div className="form-check checkbox-slider checkbox-slider--b-flat">
														<label>
															<input
                                                                name="active"
                                                                type="checkbox"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                checked={values.active}
                                                            />
															<span>&nbsp;</span>
														</label>
													</div>
												</span>
                                            </div>
                                            <div className="form-group">
                                                <TextInput
                                                    label="Name"
                                                    name="name"
                                                    value={values.name.toUpperCase()}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    errors={errors}
                                                    touched={touched}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <TextInput
                                                    label="Description"
                                                    name="description"
                                                    value={values.description}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    errors={errors}
                                                    touched={touched}
                                                    subtitle={'Description displayed to customer'}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="date">Start Date</label>
                                                <div className="customDatePickerWidth">
                                                    <DatePicker
                                                       className={"form-control text-left" +
                                                       (errors.startDate && touched.startDate ? " is-invalid" : "")}
                                                        fieldName="startDate"
                                                        placeholderText={"Select Date"}
                                                        autoFocus={false}
                                                        shouldCloseOnSelect={true}
                                                        popperPlacement={'auto'}
                                                        selected={values.startDate}
                                                        dateFormat="MM/dd/yyyy"
                                                        onChange={(date) => setFieldValue('startDate', date)}
                                                        isClearable={true}
                                                    />
                                                    {errors.startDate && touched.startDate &&
                                                    <div className="invalid-feedback">{errors.startDate}</div>
                                                    }
                                                </div>
                                                <label htmlFor="date">End Date</label>
                                                <div className="customDatePickerWidth">
                                                    <DatePicker
                                                        className={"form-control text-left"}
                                                        fieldName="endDate"
                                                        placeholderText={"Select Date"}
                                                        autoFocus={false}
                                                        shouldCloseOnSelect={true}
                                                        popperPlacement={'auto'}
                                                        selected={values.endDate}
                                                        dateFormat="MM/dd/yyyy"
                                                        isClearable={true}
                                                        onChange={(date) => setFieldValue('endDate', date)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <TextInput
                                                    label="Minimum Percentage"
                                                    name="upfrontPercentage"
                                                    type={'number'}
                                                    placeholder='0.00'
                                                    value={values.upfrontPercentage}
                                                    onChange={(e) => this.setMinPercentage(e.target.value, setFieldValue)}
                                                    onBlur={handleBlur}
                                                    errors={errors}
                                                    touched={touched}
                                                    pattern="'^[1-9]+[0-9]*$'"
                                                    min={'0.00'}
                                                    max={'100'}
                                                    subtitle={'Minimum required upfront payment'}
                                                    icon={<i className="fas fa-percent"/>}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <NumericInput
                                                    style={{
                                                        input: {
                                                            width: '75px',
                                                            textAlign: 'center'
                                                        }
                                                    }}
                                                    name={'months'}
                                                    max={12}
                                                    value={values.months}
                                                    onChange={event=>values.months=event}/>
                                                <span>&nbsp;</span>
                                                <label style={{marginBottom:'0px'}}>Months</label>
                                                <p style={{fontSize:'12px',opacity:'0.7'}}>
                                                    Number of months expected to completely pay off
			                                    </p>
                                            </div>
                                            <label>General Ledgers (optional)</label>
                                                <FieldArray name="generalLedgers"
                                                            render={({remove, push}) => <>
                                                                {values.selectedGeneralLedgers && values.selectedGeneralLedgers.map((selectedGeneralLedger, index) =>
                                                                    <div className="" key={selectedGeneralLedger.id} style={{paddingBottom: '10px',width:'675px'}}>
                                                                        <div className="card card-sm">
                                                                            <div className="card-header" style={{paddingRight: '0px'}}>
                                                                                    <div className="col-md-9" style={{paddingLeft: '0px'}}>
                                                                                        <label style={{fontSize: "0.95rem"}}>
                                                                                            {(selectedGeneralLedger.glLocationId || selectedGeneralLedger.glId || selectedGeneralLedger.glSubId ?
                                                                                                this.buildGeneralLedgerTitle(selectedGeneralLedger)
                                                                                                :
                                                                                                "General Ledger"
                                                                                            )}
                                                                                        </label>
                                                                                    </div>
                                                                                    <div style={{textAlign: "end"}}>
                                                                                        {values.selectedGeneralLedgers.length > 1 || (
                                                                                            selectedGeneralLedger.glLocationId || selectedGeneralLedger.glId || selectedGeneralLedger.glSubId) ?
                                                                                            <button
                                                                                                onClick={() => this.handleRemoveGeneralLedger(props, remove, index, setFieldValue)}
                                                                                                className="btn btn-sm btn-danger"
                                                                                                type="button"
                                                                                            >
                                                                                                Remove
                                                                                            </button>
                                                                                            : ''
                                                                                        }
                                                                                    </div>
                                                                            </div>
                                                                            <div className="card-body">
                                                                                <div className="row">
                                                                                    <div className="form-group col-sm-4">
                                                                                        <div
                                                                                            onClick={this.scrollDropdownIntoView.bind(this)}>
                                                                                            <FormSelect
                                                                                                fieldName={`selectedGeneralLedgers.${index}.glLocationId`}
                                                                                                placeholder="Select Location"
                                                                                                options={systemLocationAsOptions(removeSelectedLocations(systemLocations, index, values.selectedGeneralLedgers))}
                                                                                                setFieldValue={(e, value) => this.setGeneralLedgerLocationValue(e, value, setFieldValue, index)}
                                                                                             //   setFieldValue={setFieldValue}
                                                                                                value={selectedGeneralLedger.glLocationId}
                                                                                                onBlur={handleBlur}
                                                                                                errors={errors}
                                                                                                touched={touched}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="form-group col-sm-4">
                                                                                        <div
                                                                                            onClick={this.scrollDropdownIntoView.bind(this)}>
                                                                                            <FormSelect
                                                                                                fieldName={`selectedGeneralLedgers.${index}.glId`}
                                                                                                placeholder="Select Account"
                                                                                                options={generalLedgersAsOptions(this.props.generalLedgers)}
                                                                                                setFieldValue={(e, value) => this.setGeneralLedgerValue(e, value, setFieldValue, index)}
                                                                                                value={selectedGeneralLedger.glId}
                                                                                                onBlur={handleBlur}
                                                                                                errors={errors}
                                                                                                touched={touched}
                                                                                            />
                                                                                        </div>
                                                                                        {/* <span
                                                                                            className="text-muted">{selectedGeneralLedger.glDescription}</span> */}
                                                                                    </div>
                                                                                    <div className="form-group col-sm-4">
                                                                                        <div
                                                                                            onClick={this.scrollDropdownIntoView.bind(this)}>
                                                                                            <FormSelect
                                                                                                fieldName={`selectedGeneralLedgers.${index}.glSubId`}
                                                                                                placeholder="Select Sub Account"
                                                                                                options={generalLedgersSubAccountsAsOptions(matchCurrentSelectedGeneralLedger(this.props.generalLedgerSubAccounts, selectedGeneralLedger.glId))}
                                                                                                setFieldValue={setFieldValue}
                                                                                                value={selectedGeneralLedger.glSubId}
                                                                                                onBlur={handleBlur}
                                                                                                errors={errors}
                                                                                                touched={touched}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <span>&nbsp;</span>
                                                                <div className="clearfix">
                                                                    <button
                                                                        onClick={() => this.addAnotherGeneralLedger(values.selectedGeneralLedgers)}
                                                                        className="btn btn-sm btn-outline-secondary btn-discount-add float-right"
                                                                        type="button"
                                                                    >
                                                                        Add Another
                                                                    </button>
                                                                </div>

                                                            </>
                                                            }
                                                /> 
                                        </div>
                                        <div className="modal-footer">
                                            <button onClick={this.props.hideModal} className="btn" type="button">
                                                Cancel
                                            </button>
                                            <button disabled={isSubmitting} onClick={()=>this.formSubmit(values,actions)} type={"submit"} className="btn btn-primary">
                                                {modalProps.type === 'create' ? 'Add Installment Plan' : 'Edit Installment Plan'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        }}
                    />}
                </div>
                <div className="modal-backdrop show" tabIndex="1"/>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const modalProps = getModalData(state).modalProps,
        systemLocations = getAdmin(state).systemLocations,
        installmentplan = getProducts(state).installmentplan,
        generalLedgerSubAccounts = getAdmin(state).generalLedgerSubAccounts,
        generalLedgers = getAdmin(state).generalLedgers

    return {
        modalProps,
        systemLocations,
        installmentplan,
        generalLedgerSubAccounts,
        generalLedgers
    };
};

const mapDispatchToProps = {
    getInstallmentPlan,
    getSystemLocations,
    getGeneralLedgers,
    getGeneralLedgerSubAccounts,
    clearInstallmentPlan,
    hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(AddInstallmentPlanModal);

